import React from "react";
import { FaEye } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import useModuleListing from "../../customHooks/ModuleListing/useModuleListing";
import usePermission from "../../utils/usePermission";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useNavigate } from "react-router";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import Pagination from "react-js-pagination";

const ModuleListing = () => {
  const {
    handlePageClick,
    handlePageSizeChange,
    handleSearch,
    modules,
    totalCount,
    searchTerm,
    modulesPerPage,
    currentPage,
    openCreateModal,
    setOpenCreateModal,
    selectedModule,
    setSelectedModule,
    fetchModules,
    groupBy,
    setGroupBy,
    activeIndex,
    toggleAccordion,
    loader,
  } = useModuleListing();
  const navigate = useNavigate();
  const canRead = usePermission("MODULE_READ");
  return (
    <div>
      {canRead ? (
        <div className="container">
          <div className="mainHeader">
            <h1 className="font-semibold text-lg">Modules</h1>
            {/* <button
              className="add-plan-button"
              onClick={() => {
                setOpenCreateModal(true);
              }}
            >
              + Add New Module
            </button> */}
          </div>{" "}
          <div className="mainHeader">
            <div className="search-container">
              <input
                type="text"
                placeholder="Search..."
                className="search-input"
                value={searchTerm}
                onChange={handleSearch}
              />
              <CiSearch className="search-icon" />
            </div>
            <div className="flex gap-4 items-center">
              <div className="items-per-page-container">
                <label className="items-per-page-label">Group By</label>
                <select
                  value={groupBy}
                  onChange={(e) => setGroupBy(e.target.value)}
                  className="items-per-page-dropdown"
                >
                  <option value={"modules"}>Modules</option>
                  <option value={"module_permissions"}>
                    Module Permissions
                  </option>
                </select>
              </div>
              <div className="items-per-page-container">
                <select
                  value={modulesPerPage}
                  onChange={handlePageSizeChange}
                  className="items-per-page-dropdown"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
          </div>
          {!loader ? (
            <>
              <div className="mainContainer">
                <div className="table-container">
                  {groupBy === "modules" && (
                    <table className="data-table">
                      <thead>
                        <tr>
                          <th>Application Name</th>
                          <th>Module Name</th>
                          <th>Module Description</th>
                          <th>Actions</th>
                          <th>Permissions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {modules && modules.length > 0 ? (
                          <>
                            {modules.map((row, index) => (
                              <>
                                <tr key={index}>
                                  <td>{row.application_name || "-"}</td>
                                  <td>{row.name || "-"}</td>
                                  <td>{row.description || "-"}</td>

                                  <td>
                                    <div className="flex actionBtns">
                                      {/* {!canUpdate && (
                                      <button
                                        className="editButtom"
                                        onClick={() => {
                                          setSelectedModule(row);
                                          setOpenCreateModal(true);
                                        }}
                                      >
                                        <MdEdit />
                                      </button>
                                    )} */}
                                      <button
                                        className="editButtom"
                                        style={{ background: "" }}
                                        onClick={() => {
                                          navigate(`/module/${row.id}`);
                                        }}
                                      >
                                        <FaEye />
                                      </button>
                                    </div>
                                  </td>
                                  <td
                                    className={`toggle-indicator ${
                                      activeIndex === index ? "active" : ""
                                    }`}
                                    onClick={() => toggleAccordion(index)}
                                  >
                                    {activeIndex === index ? (
                                      <IoIosArrowUp
                                        size={20}
                                        className="font-bold"
                                      />
                                    ) : (
                                      <IoIosArrowDown
                                        size={20}
                                        className="font-bold"
                                      />
                                    )}
                                  </td>
                                </tr>
                                <tr
                                  className="accordion-content"
                                  style={{
                                    display:
                                      activeIndex === index
                                        ? "table-row"
                                        : "none",
                                  }}
                                >
                                  <td colSpan="5">
                                    <table className="nested-table">
                                      <thead>
                                        <tr>
                                          <th>Permission Name</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {row?.module_permissions?.map(
                                          (feature, i) => (
                                            <tr key={i}>
                                              <td>{feature.permissionName}</td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={5} className="text-center">
                              No Modules Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                  {groupBy === "module_permissions" && (
                    <table className="data-table">
                      <thead>
                        <tr>
                          <th>Permission Name</th>
                          <th>Module Name</th>
                          <th>Application Name</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {modules &&
                          modules.map((row, index) => (
                            <>
                              <tr key={index}>
                                <td>{row.permission_name || "-"}</td>
                                <td>{row.module_name || "-"}</td>
                                <td>{row.application_name || "-"}</td>
                                <td>
                                  <div className="actionBtns">
                                    {/* {canUpdate && (
                                      <button
                                        className="editButtom"
                                        onClick={() => {
                                          setSelectedModule(row);
                                          setOpenCreateModal(true);
                                        }}
                                      >
                                        <MdEdit />
                                      </button>
                                    )} */}

                                    <button
                                      className="editButtom"
                                      style={{ background: "" }}
                                      onClick={() => {
                                        navigate(`/module/${row.id}`);
                                      }}
                                    >
                                      <FaEye />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </>
                          ))}
                      </tbody>
                    </table>
                )} 
                </div>
              </div>
              {totalCount > modulesPerPage && (
                <div className="mt-6 flex justify-between items-center">
                  <span className="text-gray-600">
                    Showing {(currentPage - 1) * modulesPerPage + 1} to{" "}
                    {Math.min(currentPage * modulesPerPage, totalCount)} of{" "}
                    {totalCount} entries
                  </span>

                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={modulesPerPage}
                    totalItemsCount={totalCount}
                    pageRangeDisplayed={5}
                    onChange={handlePageClick}
                    nextPageText={">"}
                    prevPageText={"<"}
                    firstPageText={"<<"}
                    lastPageText={">>"}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                </div>
              )}
            </>
          ) : (
            <FullPageLoading />
          )}
        </div>
      ) : (
        <UnAuthorized />
      )}
    </div>
  );
};

export default ModuleListing;
